import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import * as moment from "moment";
import { Observable } from 'rxjs';
import { map, mergeMap, tap } from "rxjs/operators";
import { ConfigService } from "../../../../config/config.service";
import { Client } from "../../../shared/client/client";
import { ClientService } from '../../../shared/client/client.service';
import { Delivery } from '../delivery';

@Injectable({
  providedIn: 'root'
})
export class DeliveryListService {

  /**
   * @param {HttpClient} http
   * @param {ConfigService} configService
   */
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private clientService: ClientService
  ) {
  }

  /**
   *
   * @param {Client} client
   * @param {string} date
   * @returns {Observable<Object>}
   */
  getDeliveries(client: Client, date: moment.Moment = null): Observable<Array<Delivery>> {
    let body = { date: date.format('Y-MM-DD') };
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Array<Delivery>>(config.apiPoint + config.getClientDeliveries.replace("{client}", client.id), {
          params: body
        });
      }));
  }

  /**
   *
   * @param {Client} client
   * @returns {Observable<Object>}
   */
  getDates(client: Client): Observable<Array<moment.Moment>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get(
          config.apiPoint + config.getClientDeliveriesConso.replace("{client}", client.id)
        ).pipe(
          map<Array<string>, Array<moment.Moment>>(dates => {
            return dates.map(date => {
              return moment(new Date(date));
            });
          })
        )
      })
    );
  }

  /**
   * Export PDF Bordereau livraison
   * @param {Client} client
   * @param {string} date
   */
  public exportBordereauLivraison(client: Client, date: moment.Moment = null) {
    let body = { date: date.format('Y-MM-DD') };
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get(config.apiPoint + config.exportBordereauLivraison.replace("{client}", client.id), { params: body, responseType: 'arraybuffer' }).pipe(
          tap(res => {
            let blob = new Blob([res], { type: 'application/pdf' });
            let filename = `export_bordereau_livraison_${date.format('Y-MM-DD')}_client_${client.id}.pdf`;
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
        );
      })
    );
  }
}
